module.exports = __webpack_public_path__ + "img/wbicon-guangzhou.84407429.jpg";